import gql from 'graphql-tag';

export const GET_PARTNERS_PROPOSALS = gql`
  query GetPartnersProposals($accountId: ID!, $partnerLinkId: ID) {
    partnersProposals(accountId: $accountId, partnerLinkId: $partnerLinkId) {
      id
      amountRequested
      creditProductIds
      riskTier
      vendorOpportunityId
      accountId
      vendorSalespersonId
      firstName
      lastName
      email
      businessName
      status
      createdDateTime
      salesPersonName
      fullName
      account {
        name
        dynamicsAccountId
      }
      lead {
        inboundDealType
      }
    }
  }
`;
